import apiClient from "../utils/apiClient";

export const elementoPorSeccion = async (idElemento) => {
  try {
    const response = await apiClient.get(
      `/web/elementoporseccion/${idElemento}`
    );
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};
/**
 * Retrieves the list of promotions from the web activities endpoint.
 *
 * @returns {Promise<Array<Object>>} - A promise that resolves to an array of promotion objects.
 * @throws {Error} - Throws an error if the connection fails.
 */

export const getProductsBySection = async (section) => {
  try {
    const response = await apiClient.get(`/web/actividades/${section}`);
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};

/**
 * Fetches the hotel markup data from the system.
 *
 * @returns {Promise<Object>} - An object containing the hotel markup data.
 * @throws {Error} - Throws an error if the connection fails.
 */

export const getMarkup = async () => {
  try {
    const response = await apiClient.get(`/sys/markup/HOTELERIA`);
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};
export const getCurrencyExchange = async () => {
  try {
    const response = await apiClient.get(`/conversionPesos`);
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};

/**
 * Obtiene la lista de promociones.
 *
 * @returns {Promise<Array<Object>>} - Un arreglo de objetos con la lista de secciones.
 *
 * @throws {Error} - Lanza un error si la solicitud falla.
 */
export const getFiltersBySection = async (section) => {
  try {
    const response = await apiClient.get(`/obtener_destino_seccion/${section}`);
    return response.data;
  } catch (e) {
    throw new Error("error connection", e);
  }
};
